// Presentation only: preserve native constraints and existing submit handlers.
export const localizeInvalidField = event => {
  const field = event.target;
  if (typeof field.setCustomValidity !== "function") return;
  const v = field.validity;
  let message = "Ελέγξτε την τιμή αυτού του πεδίου.";
  if (v.valueMissing) message = field.type === "checkbox" ? "Αποδεχτείτε αυτή την επιλογή για να συνεχίσετε." : "Συμπληρώστε αυτό το πεδίο.";
  else if (v.typeMismatch) message = field.type === "email" ? "Εισαγάγετε μια έγκυρη ηλεκτρονική διεύθυνση." : "Εισαγάγετε μια έγκυρη τιμή.";
  else if (v.rangeUnderflow) message = `Η ελάχιστη επιτρεπτή τιμή είναι ${field.min}.`;
  else if (v.rangeOverflow) message = `Η μέγιστη επιτρεπτή τιμή είναι ${field.max}.`;
  else if (v.tooShort) message = `Χρειάζονται τουλάχιστον ${field.minLength} χαρακτήρες.`;
  else if (v.patternMismatch) message = "Η τιμή δεν έχει την απαιτούμενη μορφή.";
  else if (v.badInput || v.stepMismatch) message = "Εισαγάγετε έναν έγκυρο αριθμό.";
  field.setCustomValidity(message);
};
export const clearFieldMessage = event => {
  if (typeof event.target.setCustomValidity === "function") event.target.setCustomValidity("");
};